import { css as u, LitElement as h, html as c } from "lit";
import { property as a, customElement as v } from "lit/decorators.js";
import { classMap as m } from "lit/directives/class-map.js";
import { b as f, f as g } from "./styles-scZ6dVz-.js";
import { b, a as y } from "./events-CkEPl0SM.js";
var x = Object.defineProperty, S = Object.getOwnPropertyDescriptor, e = (t, r, n, o) => {
  for (var l = o > 1 ? void 0 : o ? S(r, n) : r, d = t.length - 1, p; d >= 0; d--)
    (p = t[d]) && (l = (o ? p(r, n, l) : p(l)) || l);
  return o && l && x(r, n, l), l;
};
let i = class extends h {
  constructor() {
    super(...arguments), this.value = "", this.variant = "pill", this.size = "md", this.fullWidth = !1;
  }
  updated(t) {
    (t.has("value") || t.has("variant") || t.has("size") || t.has("fullWidth")) && this.syncItems();
  }
  handleSelect(t) {
    this.value = t.detail.value, b(this, y.CHANGE, { value: this.value }), this.syncItems();
  }
  handleSlotChange() {
    this.syncItems();
  }
  syncItems() {
    const t = Array.from(this.querySelectorAll("ark-segmented-item"));
    for (const r of t)
      r.selected = r.value === this.value, r.variant = this.variant, r.size = this.size, r.fullWidth = this.fullWidth;
  }
  render() {
    const t = {
      group: !0,
      [this.variant]: !0,
      "full-width": this.fullWidth
    };
    return c`
      <div part="group" class=${m(t)} @ark-select=${this.handleSelect}>
        <slot @slotchange=${this.handleSlotChange}></slot>
      </div>
    `;
  }
};
i.styles = [
  f,
  u`
      :host {
        display: block;
      }

      .group {
        display: flex;
        gap: var(--ark-segmented-gap, var(--r5-space-2));
      }

      .underline {
        border-bottom: 1px solid var(--r5-border);
        padding-bottom: var(--r5-space-px);
        gap: var(--ark-segmented-gap, var(--r5-space-6));
      }

      .full-width {
        width: 100%;
      }
    `
];
e([
  a({ type: String, reflect: !0 })
], i.prototype, "value", 2);
e([
  a({ type: String, reflect: !0 })
], i.prototype, "variant", 2);
e([
  a({ type: String, reflect: !0 })
], i.prototype, "size", 2);
e([
  a({ type: Boolean, attribute: "full-width" })
], i.prototype, "fullWidth", 2);
i = e([
  v("ark-segmented")
], i);
let s = class extends h {
  constructor() {
    super(...arguments), this.value = "", this.selected = !1, this.disabled = !1, this.size = "md", this.variant = "pill", this.fullWidth = !1;
  }
  handleClick() {
    this.disabled || b(this, y.SELECT, { value: this.value });
  }
  render() {
    const t = {
      [this.size]: !0,
      [this.variant]: !0,
      "focus-ring": !0
    };
    return c`
      <button
        part="button"
        class=${m(t)}
        ?disabled=${this.disabled}
        aria-pressed=${this.selected ? "true" : "false"}
        @click=${this.handleClick}
      >
        <slot></slot>
      </button>
    `;
  }
};
s.styles = [
  f,
  g,
  u`
      :host {
        display: inline-flex;
      }

      :host([full-width]) {
        flex: 1;
      }

      button {
        display: inline-flex;
        align-items: center;
        gap: var(--r5-space-1);
        border-radius: var(--r5-radius-md);
        border: 1px solid var(--r5-border);
        background: var(--r5-bg);
        color: var(--r5-text-muted);
        cursor: pointer;
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
        font-family: inherit;
        white-space: nowrap;
      }

      button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      /* Sizes */
      .sm {
        height: var(--r5-button-height-sm);
        padding: 0 var(--r5-space-2-5);
        font-size: var(--r5-text-xs);
      }

      .md {
        height: var(--r5-button-height-md);
        padding: 0 var(--r5-space-3);
        font-size: var(--r5-text-sm);
      }

      /* Pill variant */
      .pill:hover:not(:disabled) {
        background: var(--r5-muted);
        color: var(--r5-text);
      }

      :host([selected]) .pill {
        background: var(--r5-color-primary-600);
        border-color: var(--r5-color-primary-600);
        color: white;
      }

      /* Underline variant */
      .underline {
        border: none;
        border-bottom: 2px solid transparent;
        border-radius: 0;
        background: transparent;
        padding: var(--r5-space-3) 0;
      }

      .underline:hover:not(:disabled) {
        color: var(--r5-text);
        border-bottom-color: var(--r5-border);
      }

      :host([selected]) .underline {
        color: var(--r5-color-primary-600);
        border-bottom-color: var(--r5-color-primary-600);
      }
    `
];
e([
  a({ type: String })
], s.prototype, "value", 2);
e([
  a({ type: Boolean, reflect: !0 })
], s.prototype, "selected", 2);
e([
  a({ type: Boolean, reflect: !0 })
], s.prototype, "disabled", 2);
e([
  a({ type: String })
], s.prototype, "size", 2);
e([
  a({ type: String })
], s.prototype, "variant", 2);
e([
  a({ type: Boolean, attribute: "full-width", reflect: !0 })
], s.prototype, "fullWidth", 2);
s = e([
  v("ark-segmented-item")
], s);
export {
  i as A,
  s as a
};
//# sourceMappingURL=ark-segmented-D20wm7js.js.map
